import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

const Considerapp = () => {
  return (
    <div className="consider_usa p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={5} xxl={5}>
                        <div className="consider_content">
                                <h2>Choosing the Best Time for Our Startup Prototype Services</h2>
                               <p>Timing matters! Consider our Startup Prototype Services when validating your product idea. We bring qualified talent to every developmental stage, warranting your idea grows impeccably. Change your vision into reality with accuracy and innovation, teaming with us for unmatched startup support.</p> 
                               <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact"> Build Your Idea Now</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
                    <div className="consider-box">
                        <h6>Early Validation:</h6>
                        <p>Choose our services when you need instant validation of your startup concept, guaranteeing feasibility and market appeal before devoting further resources.</p>
                    </div>
                    <div className="consider-box">
                        <h6>Startup Prototyping Development Milestones:</h6>
                        <p>Engage with us at pivotal development junctures to align prototype development with strategic milestones, restructuring the evolution of your product idea.</p>
                    </div>
                    <div className="consider-box">
                        <h6>Investor Readiness:</h6>
                        <p>Select our Startup Prototype Services when preparing to entice investors, bestowing a tangible and impressive prototype that inspires confidence in the viability of your business idea.</p>
                    </div>
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Considerapp